import React from 'react'
import { WHY_SAATCHI_DATA, CAPABILITIES } from '../../helpers/constants'
import { WhySaatchi } from './styles'
type Props = {
  section: string
}

const Component = ({ section }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <WhySaatchi>
      <p
        data-type='subtitle'
        data-style='why-saatchi-subtitle'
        {...(section === CAPABILITIES
          ? {
              'data-style': 'hide',
            }
          : {})}
      >
        Why Saatchi Art?
      </p>
      <p data-type='text' data-style='why-saatchi-text'>
        {WHY_SAATCHI_DATA[section]}
      </p>
    </WhySaatchi>
  )
}

export default Component